export default "__VITE_ASSET__D9t0wesq__"